module.exports = __webpack_public_path__ + "static/atlaskit-page-basic-c2f8fbc917db539580e8c38c72119c32.png";